import { ReactNode } from "react";
import styled, { css } from "styled-components";
import { onDesktop } from "@teamscheme/theme";

export interface CardSectionProps {
  title?: ReactNode;
  ingress?: ReactNode;
  ingressClassName?: string;
  className?: string;
  children?: ReactNode;
}

export const CardSectionTitle = styled.h2``;

export const CardSectionHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space48};

  p {
    text-align: left;
  }
`;

const CardSection = styled(function ({
  title,
  ingress,
  ingressClassName,
  children,
  className,
}: CardSectionProps) {
  return (
    <section
      className={["CardSection", className].filter((c) => !!c).join(" ")}
    >
      {title || ingress ? (
        <CardSectionHeader>
          <CardSectionTitle>{title}</CardSectionTitle>
          {ingress && <p className={ingressClassName}>{ingress}</p>}
        </CardSectionHeader>
      ) : null}
      {children}
    </section>
  );
})`
  ${CardSectionHeader} ${CardSectionTitle}:last-child {
    margin-bottom: 0;
  }

  .CardSection-header p {
    text-align: left;
  }

  ${({ theme }) =>
    css`
      margin-bottom: ${theme.spacing.space24};

      ${onDesktop`
        margin-bottom: ${theme.spacing.space32};
      `}
    `};
`;

export const TitleSection = styled(CardSection)`
  ${CardSectionTitle} {
    ${({ theme }) => theme.mobileFontStyle.headers.header1};
    ${({ theme }) => onDesktop`
    ${theme.fontStyle.headers.header1}
  `}
  }
`;

export default CardSection;
